import React from "react";
import {
  ArrowIconTabButton,
  SelectionTabButton,
} from "../AllButton/SelectionTabButton";

export const MobileTabDesign = ({ state, localProps }) => {
  return (
    <React.Fragment>
      <div className="service-top-tab-button mobile-service-top-tab-button">
        <ArrowIconTabButton
          buttonClass="small-tab-button-section-left"
          buttonIconDisplay={true}
          onClick={localProps.tabBackButtonClicked}
        />
        <SelectionTabButton
          buttonClass={
            state.casual_dining ? "top-tab-button-section-active" : ""
          }
          buttonIcon={require("../../../../assets/images/ActionImages/order.svg")}
          buttonText={"Casual / Fine Dining"}
          onClick={localProps.casualDiningManagementButton}
        />
        <SelectionTabButton
          buttonClass={
            state.fast_food_dining ? "top-tab-button-section-active" : ""
          }
          buttonIcon={require("../../../../assets/images/ActionImages/order.svg")}
          buttonText={"Fast Food and other"}
          onClick={localProps.fastFoodOthersManagement}
        />
        <SelectionTabButton
          buttonClass={
            state.hospitality_hotels ? "top-tab-button-section-active" : ""
          }
          buttonIcon={require("../../../../assets/images/ActionImages/order.svg")}
          buttonText={"Hospitality & Hotels"}
          onClick={localProps.hospitalityHotelsManagement}
        />
        <SelectionTabButton
          buttonClass={
            state.multi_service_business ? "top-tab-button-section-active" : ""
          }
          buttonIcon={require("../../../../assets/images/ActionImages/order.svg")}
          buttonText={"Multi Service Business"}
          onClick={localProps.multiServiceManagementButton}
        />
        <ArrowIconTabButton
          buttonClass="small-tab-button-section-right"
          buttonIconDisplay={false}
          onClick={localProps.tabNextButtonClicked}
        />
      </div>
    </React.Fragment>
  );
};
